import React from 'react';

import { CenteredCircularProgress } from 'components/Progress';

import { LoadingContainer } from 'containers/Tiptap/components/tiptap-templates/styles';

interface EditorLoadingStatesProps {
  type: 'loading' | 'error' | 'editorError';
}

export const EditorLoadingStates: React.FC<EditorLoadingStatesProps> = ({ type }) => {
  if (type === 'loading') {
    return (
      <LoadingContainer>
        <CenteredCircularProgress />
      </LoadingContainer>
    );
  }

  if (type === 'editorError') {
    return (
      <LoadingContainer>
        <h1>Error loading editor</h1>
      </LoadingContainer>
    );
  }

  return (
    <LoadingContainer>
      <h1>Error connecting to the document</h1>
    </LoadingContainer>
  );
};
